import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Typography,
  Modal,
  Menu,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  TextField,
  Button,
  IconButton,
  CircularProgress,
  TablePagination,
} from "@mui/material";
import { useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import { useFetch, useDelete, useUpdate } from "../../hooks";

import SnackbarComponent from "../../components/SnackBar/snackBar";

import { MoreVert, Close } from "@mui/icons-material";

const vendorsData = [
  {
    sno: 1,
    variantName: "Variant A",
    category: "Category 1",
    subCategory: "Sub-category 1",
  },
  {
    sno: 2,
    variantName: "Variant B",
    category: "Category 2",
    subCategory: "Sub-category 2",
  },
];

const categoryOptions = ["Category 1", "Category 2"];
const subCategoryOptions = ["Sub-category 1", "Sub-category 2"];
const variantOptions = ["Variant A", "Variant B", "Variant C"];

export default function AdminProductVariant() {
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const [snackbarState, setSnackbarState] = useState({
    open: false,
    severity: "success", // Default severity
    message: "",
    position: { vertical: "top", horizontal: "center" },
  });
  const [vendors, setVendors] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [search, setSearch] = useState("");

  const [categoryNameError, setCategoryNameError] = useState("");
  const [subCategoryNameError, setSubCategoryNameError] = useState("");
  const [variantError, setVariantNameError] = useState("");
  const [categoriesData, setCategoriesData] = useState([]);
  const [subCategoriesDataArray, setSubCategoriesData] = useState([]);
  const [newVendor, setNewVendor] = useState({
    sno: "",
    variantName: "",
    category: "",
    subCategory: "",
    properties: "",
  });
  const loginToken = useSelector((state) => state.user.logintoken);

  const getInitialFormValues = () => ({
    category_id: selectedVendor ? selectedVendor.category_id : "",
    category_name: selectedVendor ? selectedVendor.name : "",
    subCategory_id: selectedVendor ? selectedVendor.subCategory_id : "",
    subCategory_name: selectedVendor ? selectedVendor.subCategory_name : "",
    variant_id: selectedVendor ? selectedVendor.subCategory_name : "",
    variant_name: selectedVendor ? selectedVendor.subCategory_name : "",
    description: selectedVendor ? selectedVendor.description : "",
    image: selectedVendor ? selectedVendor.image_url : "",
    status: selectedVendor ? selectedVendor.status : "",
  });
  const [formValues, setFormValues] = useState(getInitialFormValues());

  useEffect(() => {
    fetchData();
    categoriesFetchData();
    subCategoriesFetchData();
  }, []);

  const {
    data: categoryData,
    error: categoriesError,
    fetchData: categoriesFetchData,
  } = useFetch(BASE_URL_TEST + urls("getAllCategories"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });
  const {
    data: subCategoryData,
    error: subCategoriesError,
    fetchData: subCategoriesFetchData,
  } = useFetch(BASE_URL_TEST + urls("getAllSubCategories"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: variantData,
    isLoading: isVariantLoading,
    error,
    fetchData,
  } = useFetch(BASE_URL_TEST + urls("getAllVariants"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  useEffect(() => {
    if (error) {
    } else if (variantData && variantData.status == true) {
      setVendors(variantData["data"]);
    }
  }, [variantData, error]);

  useEffect(() => {
    if (categoriesError) {
    } else if (categoryData && categoryData.status == true) {
      // setVendors(variantData['data'])
      console.log("categoriesData", categoryData["data"]);
      setCategoriesData(categoryData["data"]);
    }
  }, [categoryData, categoriesError]);

  useEffect(() => {
    if (subCategoriesError) {
    } else if (subCategoryData && subCategoryData.status == true) {
      // setVendors(variantData['data'])
      console.log("subCategoriesData", subCategoryData["data"]);
      setSubCategoriesData(subCategoryData["data"]);
    }
  }, [subCategoryData, subCategoriesError]);

  const {
    data: createVariantData,
    error: createVariantError,
    fetchData: fetchCreateData,
  } = useFetch(BASE_URL_TEST + urls("createVariants"), {
    method: "POST",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: updatedVariantData,
    isLoading: updatedVariantLoading,
    error: updatedVariantError,
    updateData: fetchUpdateData,
  } = useUpdate(BASE_URL_TEST, {
    method: "PUT",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: deletedVariantData,
    error: deletedVariantError,
    deleteData: fetchDeleteData,
  } = useDelete(BASE_URL_TEST, {
    method: "DELETE",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  useEffect(() => {
    if (createVariantError) {
    } else if (createVariantData && createVariantData["status"] === true) {
      console.log("variantData", createVariantData["data"]);
      setCategoryNameError("");
      setSubCategoryNameError("");
      setVariantNameError("");
      setSnackbarState({
        ...snackbarState,
        open: true,
        message: createVariantData["message"],
        position: { vertical: "top", horizontal: "center" },
        severity: "success",
      });
      setModalOpen(false);
      fetchData();
    }
  }, [createVariantData, createVariantError]);

  useEffect(() => {
    if (updatedVariantError) {
    } else if (updatedVariantData && updatedVariantData["status"] === true) {
      console.log("updatedVariantData", updatedVariantData["data"]);
      setSnackbarState({
        ...snackbarState,
        open: true,
        message: updatedVariantData["message"],
        position: { vertical: "top", horizontal: "center" },
        severity: "success",
      });
      setModalOpen(false);
      setFormValues({});
      fetchData();
    }
  }, [updatedVariantData, updatedVariantError]);

  useEffect(() => {
    if (deletedVariantError) {
    } else if (deletedVariantData && deletedVariantData["status"] === true) {
      // console.log("updatedVariantData",updatedVariantData['data'])
      setSnackbarState({
        ...snackbarState,
        open: true,
        message: deletedVariantData["message"],
        position: { vertical: "top", horizontal: "center" },
        severity: "success",
      });
      setModalOpen(false);
      fetchData();
    }
  }, [deletedVariantData, deletedVariantError]);

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearch = (event) => {
    setSearch(event.target.value);
  };

  const filteredData = search
    ? vendors.filter(
        (item) =>
          (item?.title?.toLowerCase()?.includes(search.toLowerCase()) ??
            false) ||
          (item?.category_name?.toLowerCase()?.includes(search.toLowerCase()) ??
            false) ||
          (item?.sub_category_name
            ?.toLowerCase()
            ?.includes(search.toLowerCase()) ??
            false),
      )
    : vendors;

  const handleMenuClick = (event, vendor) => {
    setAnchorEl(event.currentTarget);
    setSelectedVendor(vendor);
    console.log("variant edit", vendor);
    setFormValues({
      category_id: vendor.category_id || "",
      category_name: vendor.category_name || "",
      subCategory_id: vendor.sub_cat_id || "",
      subCategory_name: vendor.sub_category_name || "",
      variant_id: vendor.variant_id || "",
      variant_name: vendor.title || "",
      status: vendor.status !== undefined ? vendor.status : 1, // Ensure status is set
    });
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedVendor(null);
  };

  const handleEditVendor = () => {
    setModalOpen(true);
    setIsEditing(true);
    setNewVendor(selectedVendor);
    handleMenuClose();
  };

  const handleDelete = () => {
    // setVendors(vendors.filter((v) => v.sno !== selectedVendor.sno));
    const deleteUrl = urls("deleteVariants", selectedVendor["variant_id"]);
    fetchDeleteData(deleteUrl);
  };

  const handleAddVendor = () => {
    if (isEditing) {
      console.log("formValues", formValues);

      const raw = {
        category_id: formValues["category_id"],
        sub_cat_id: formValues["subCategory_id"],
        title: formValues["variant_name"],
        status: formValues["status"],
      };

      const updateUrl = urls("updateVariants", formValues["variant_id"]);
      fetchUpdateData(updateUrl, raw);
    } else {
      // Add a new vendor
      // setVendors([...vendors, { ...newVendor, sno: vendors.length + 1 }]);
      console.log("variantVendors", formValues);
      if (formValues) {
        if (!formValues["category_id"]) {
          setCategoryNameError("Category name is required");
          return;
        } else if (!formValues["subCategory_id"]) {
          setSubCategoryNameError("Category name is required");
          return;
        } else if (!formValues["variant_name"]) {
          setVariantNameError("Variant name is required");
          return;
        } else {
          fetchCreateData({
            category_id: formValues["category_id"],
            sub_cat_id: formValues["subCategory_id"],
            title: formValues["variant_name"],
          });
        }
      }
    }

    // Reset modal state
    // setModalOpen(false);
    setNewVendor({
      sno: "",
      variantName: "",
      category: "",
      subCategory: "",
    });
    setIsEditing(false);
  };

  const handleSnackbarClose = () => {
    setSnackbarState((prev) => ({ ...prev, open: false }));
  };

  return (
    <Box sx={{ padding: 3, backgroundColor: "#F9FAFC" }}>
      <SnackbarComponent
        open={snackbarState.open}
        onClose={handleSnackbarClose}
        severity={snackbarState.severity}
        message={snackbarState.message}
        position={snackbarState.position}
      />
      {/* Add Button */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          borderRadius: "20px",
        }}
      >
        <TextField
          variant="outlined"
          placeholder="Search"
          size="small"
          value={search}
          onChange={handleSearch}
          sx={{
            width: "30%",
            backgroundColor: "#FFF",
            borderRadius: 1,
          }}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            setModalOpen(true);
            setIsEditing(false); // Ensure this is a new entry
          }}
          sx={{
            backgroundColor: "#28A745",
            "&:hover": { backgroundColor: "#218838" },
            textTransform: "none",
            fontWeight: "bold",
          }}
        >
          Add Variant
        </Button>
      </Box>

      <Box>
        {isVariantLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
            <CircularProgress />
          </Box>
        ) : null}
      </Box>

      {/* Vendor Table */}
      <TableContainer
        component={Paper}
        sx={{ borderRadius: "20px", p: 0, borderRadius: 2, boxShadow: 2 }}
      >
        <Table>
          <TableHead sx={{ backgroundColor: "#F5F5F5" }}>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>V.no</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Variant Name</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Category</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Sub-Category</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {filteredData && filteredData.length > 0 ? (
              filteredData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((vendor) => (
                  <TableRow key={vendor.variant_id}>
                    <TableCell>{vendor.variant_id}</TableCell>
                    <TableCell>{vendor.title}</TableCell>
                    <TableCell>{vendor.category_name}</TableCell>
                    <TableCell>{vendor.sub_category_name}</TableCell>
                    <TableCell>
                      <Typography
                        color={vendor.status === 1 ? "green" : "gray"}
                        fontWeight={"bold"}
                      >
                        {vendor.status === 1 ? "Active" : "InActive"}
                      </Typography>
                    </TableCell>

                    {/* Action Column with 3 Dots Menu */}
                    <TableCell>
                      <IconButton onClick={(e) => handleMenuClick(e, vendor)}>
                        <MoreVert />
                      </IconButton>
                      <Menu
                        anchorEl={anchorEl}
                        open={
                          Boolean(anchorEl) &&
                          selectedVendor?.sno === vendor.sno
                        }
                        onClose={handleMenuClose}
                      >
                        <MenuItem onClick={handleEditVendor}>Edit</MenuItem>

                        <MenuItem
                          sx={{ display: "none" }}
                          onClick={handleDelete}
                        >
                          Delete
                        </MenuItem>
                      </Menu>
                    </TableCell>
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell colSpan={4} style={{ textAlign: "center" }}>
                  No data found for the searched product.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={vendors && vendors.length ? vendors.length : 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      {/* Add/Edit Vendor Modal */}
      <Modal open={isModalOpen} onClose={() => setModalOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "calc(100vw - 24px)", sm: 400 },
            maxWidth: "100%",
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography variant="h6" mb={2}>
            {isEditing ? "Edit Variant" : "Add Variant"}
          </Typography>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel id="from-label-category">Category</InputLabel>
            <Select
              native
              // value={isEditing && selectedVendor ? selectedVendor.category_id :newVendor.category}
              // value={
              //   newVendor.category ||
              //   (selectedVendor && selectedVendor.category_id) ||
              //   ""
              // }
              value={formValues.category_id}
              error={!!categoryNameError}
              onChange={(e) =>
                // setNewVendor({ ...newVendor, : e.target.value })
                setFormValues({ ...formValues, category_id: e.target.value })
              }
              label="Category"
            >
              <option value="" />
              {categoriesData.map((category) => (
                <option key={category.category_id} value={category.category_id}>
                  {category.name}
                </option>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Sub-Category</InputLabel>
            <Select
              native
              // value={isEditing && selectedVendor  ? selectedVendor.sub_cat_id: newVendor.subCategory}
              value={formValues.subCategory_id}
              error={!!subCategoryNameError}
              onChange={(e) =>
                // setNewVendor({ ...newVendor, subCategory: e.target.value })
                setFormValues({ ...formValues, subCategory_id: e.target.value })
              }
              label="Sub-Category"
            >
              <option value="" />
              {subCategoriesDataArray.map((subCategory) => (
                <option
                  key={subCategory.sub_cat_id}
                  value={subCategory.sub_cat_id}
                >
                  {subCategory.name}
                </option>
              ))}
            </Select>
          </FormControl>

          <TextField
            fullWidth
            label="Variant Name"
            variant="outlined"
            // value={newVendor.variantName}
            value={formValues.variant_name}
            onChange={
              (e) =>
                setFormValues({ ...formValues, variant_name: e.target.value })
              // setNewVendor({...newVendor,variantName:e.target.value})
            }
            sx={{ mb: 2 }}
            error={!!variantError}
            helperText={
              variantError && (
                <Typography
                  sx={{ textAlign: "left", marginTop: 1, color: "red" }}
                >
                  {variantError}
                </Typography>
              )
            }
          />
          {isEditing ? (
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Status</InputLabel>
              <Select
                //  value={newVendor.status==0?0: 1} // Default to 1 (Active)
                value={formValues.status}
                onChange={(e) => {
                  console.log("select", e.target.value);
                  // setNewVendor((prev) => ({ ...prev, status: e.target.value }))
                  setFormValues({ ...formValues, status: e.target.value });
                }}
                label="Status"
              >
                <MenuItem value={1}>Active</MenuItem>
                <MenuItem value={0}>Deactive</MenuItem>
              </Select>
            </FormControl>
          ) : null}
          <Box sx={{ mb: 2 }}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleAddVendor}
              sx={{ mb: 1 }}
            >
              {isEditing ? "Update" : "Add Variant"}
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              fullWidth
              // onClick={handleCloseModal}
              onClick={() => setModalOpen(false)}
            >
              CLOSE
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
